import clsx from 'clsx';
import { CircleX } from 'lucide-react';
import { CSSProperties, DetailedHTMLProps, TextareaHTMLAttributes } from 'react';
import inputStyles from './Input.module.scss';
import styles from './TextArea.module.scss';

export type TextAreaProps = {
  label?: React.ReactNode;
  error?: React.ReactNode;
  inputStyle?: CSSProperties;
} & DetailedHTMLProps<TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>;

const TextArea: React.FC<TextAreaProps> = ({ className, error, label, inputStyle, ...props }) => {
  return (
    <label className={clsx(inputStyles.field, { [inputStyles.error]: error != undefined })}>
      {label && <span className={inputStyles.label}>{label}</span>}
      <span className={inputStyles.inputWrapper}>
        <textarea
          style={inputStyle}
          className={clsx(styles.textarea, className)}
          {...props}
        ></textarea>
        {error && (
          <span className={inputStyles.errorLabel}>
            <CircleX size={14} />
            <span>{error}</span>
          </span>
        )}
      </span>
    </label>
  );
};

export default TextArea;
